import { InlineLink, TextBase, TextLargeParagraph } from '@carboncopyco/ui';

const SpeakerNotesBody = ({
  speakerNotes,
  onLearnMore,
}: {
  speakerNotes: string | undefined;
  onLearnMore: undefined | (() => void);
}) =>
  speakerNotes ? (
    <div className="w-full flex flex-col w-ds-400 h-ds-220 scrollbar scrollbar-thumb-gray-900 scrollbar-track-gray-100 pt-5">
      <div
        style={{
          wordWrap: 'break-word',
        }}
        className="h-ds-220 overflow-y-auto overflow-x-hidden select-auto no-drag [&::-webkit-scrollbar]:w-[7px] [&::-webkit-scrollbar]:bg-transparent [&::-webkit-scrollbar-thumb]:rounded  [&::-webkit-scrollbar-thumb]:bg-ds-natural-500 "
      >
        <TextLargeParagraph
          label={speakerNotes
            .split('\n')
            .map((str: string, index) => (
              <p key={`${str}${index}`}>{str === '' ? '\u00A0' : str}</p>
            ))}
          color="text-ds-natural-600"
          tagName="span"
        />
      </div>
    </div>
  ) : (
    <div className="w-full flex h-24 justify-center items-center justify-items-center">
      <TextBase
        label="This demo has no notes yet."
        color="text-ds-natural-600"
      />
      {onLearnMore && (
        <span className="inline-flex cursor-pointer">
          <InlineLink
            label="Learn more"
            color="text-ds-natural-600"
            onClick={onLearnMore}
            className="pl-1 pb-0.5"
          />
        </span>
      )}
    </div>
  );

export default SpeakerNotesBody;
